import { toE164 } from './phone';

// BL-177 Step 2d (section 3): what a phone field stores. E.164 whenever the number parses as valid
// (+14045942667). Anything that can't be parsed (a short code, an extension, legacy free text) is kept as
// typed rather than blocking the save -- those rows simply show as typed until someone corrects them.

/** The stored value for one phone field: E.164 when valid, otherwise the trimmed text, '' when blank. */
export function phoneForSave(value, defaultCountry = 'US') {
    const text = typeof value === 'string' ? value.trim() : '';
    if (!text) return '';
    return toE164(text, defaultCountry) || text;
}

/** The same, as the TEXT[] `phones` column on contacts: [] when blank. */
export function phonesForSave(value, defaultCountry = 'US') {
    const stored = phoneForSave(value, defaultCountry);
    return stored ? [stored] : [];
}

/** True when a non-blank phone could not be turned into E.164 (it will be stored as typed). */
export function isUnparsedPhone(value, defaultCountry = 'US') {
    const text = typeof value === 'string' ? value.trim() : '';
    return Boolean(text) && !toE164(text, defaultCountry);
}
